export const Users = [
  {
    id:1,
    profilePicture: "assets/person/human_1.jpg",
    username: "George Kocaoglu",
  },
  {
    id:2,
    profilePicture: "assets/person/human_2.jpg",
    username: "Janell Shrum",
  },
  {
    id:3,
    profilePicture: "assets/person/human_3.jpg",
    username: "Alex Durden",
  },
  {
    id:4,
    profilePicture: "assets/person/human_4.jpg",
    username: "Dora Hawks",
  },
  {
    id:5,
    profilePicture: "assets/person/human_5.jpg",
    username: "Thomas Holden",
  },
  {
    id:6,
    profilePicture: "assets/person/human_6.jpg",
    username: "Donna Lewis",
  },
  {
    id:7,
    profilePicture: "assets/person/human_7.jpg",
    username: "Shirley Beauchamp",
  },
  {
    id:8,
    profilePicture: "assets/person/human_8.jpg",
    username: "Kristen Parker",
  },
  {
    id:9,
    profilePicture: "assets/person/human_9.jpg",
    username: "Gary Collins",
  },
  {
    id:10,
    profilePicture: "assets/person/human_10.jpg",
    username: "Safak Simpson",
  },
  {
    id:11,
    profilePicture: "assets/person/human_11.jpg",
    username: "Bob Carter",
  },
  {
    id:12,
    profilePicture: "assets/person/human_12.jpg",
    username: "Kristine Scott",
  },
  {
    id:13,
    profilePicture: "assets/person/human_13.jpg",
    username: "Arthur Harrison",
  },
  {
    id:14,
    profilePicture: "assets/person/human_14.jpg",
    username: "Peter Cox",
  },
  {
    id:15,
    profilePicture: "assets/person/human_15.jpg",
    username: "Milena White",
  },
  {
    id:16,
    profilePicture: "assets/person/human_16.jpg",
    username: "Camilla Lee",
  },
  {
    id:17,
    profilePicture: "assets/person/human_17.jpg",
    username: "Henry Foster",
  },
  {
    id:18,
    profilePicture: "assets/person/human_18.jpg",
    username: "James Cooper",
  },
  {
    id:19,
    profilePicture: "assets/person/human_19.jpg",
    username: "Andrew Moore",
  },
  {
    id:20,
    profilePicture: "assets/person/human_20.jpg",
    username: "Joy Marshall",
  }
];

export const OnlineUsers = [
  {
    id:5,
    profilePicture: "assets/person/human_5.jpg",
    username: "Thomas Holden",
  },
  {
    id:13,
    profilePicture: "assets/person/human_13.jpg",
    username: "Arthur Harrison",
  },
  {
    id:7,
    profilePicture: "assets/person/human_7.jpg",
    username: "Shirley Beauchamp",
  },
  {
    id:3,
    profilePicture: "assets/person/human_3.jpg",
    username: "Alex Durden",
  },
  {
    id:9,
    profilePicture: "assets/person/human_9.jpg",
    username: "Gary Collins",
  },
  {
    id:10,
    profilePicture: "assets/person/human_10.jpg",
    username: "Safak Simpson",
  },
  {
    id:15,
    profilePicture: "assets/person/human_15.jpg",
    username: "Milena White",
  },
  {
    id:14,
    profilePicture: "assets/person/human_14.jpg",
    username: "Peter Cox",
  },
  {
    id:18,
    profilePicture: "assets/person/human_18.jpg",
    username: "James Cooper",
  },
  {
    id:16,
    profilePicture: "assets/person/human_16.jpg",
    username: "Camilla Lee",
  },
  {
    id:19,
    profilePicture: "assets/person/human_19.jpg",
    username: "Andrew Moore",
  },
];

export const Posts = [
  {
    id: 1,
    desc: "selfie!",
    photo: "assets/post/1.jpg",
    date: "5 mins ago",
    userId: 11,
    like: 29,
    comment: 5,
  },
  {
    id: 2,
    desc: "on the road",
    photo: "assets/post/2.jpg",
    date: "20 mins ago",
    userId: 11,
    like: 63,
    comment: 12,
  },
  {
    id: 3,
    desc: "Never regret anything that made you smile.",
    photo: "",
    date: "30 mins ago",
    userId: 10,
    like: 2,
    comment: 1,
  },
  {
    id: 4,
    desc: "Be different",
    photo: "assets/post/3.jpg",
    date: "1 hour ago",
    userId: 18,
    like: 6,
    comment: 1,
  },
  {
    id: 5,
    desc: "Thanks for choosing us...",
    photo: "assets/post/4.jpg",
    date: "1 hour ago",
    userId: 8,
    like: 21,
    comment: 13,
  },
  {
    id: 6,
    desc: "Change the world by being yourself.",
    photo: "",
    date: "2 hour ago",
    userId: 9,
    like: 11,
    comment: 2,
  },
  {
    id: 7,
    desc: "yum",
    photo: "assets/post/5.jpg",
    date: "3 hour ago",
    userId: 12,
    like: 6,
    comment: 4,
  },
  {
    id: 8,
    desc: "so proud of my granddaughter",
    photo: "assets/post/6.jpg",
    date: "6 hour ago",
    userId: 4,
    like: 12,
    comment: 9,
  },
  {
    id: 9,
    desc: "my favorite, I love her",
    photo: "assets/post/7.jpg",
    date: "7 hour ago",
    userId: 11,
    like: 20,
    comment: 6,
  },
  {
    id: 10,
    desc: "what do you think?",
    photo: "assets/post/8.jpg",
    date: "10 hour ago",
    userId: 2,
    like: 25,
    comment: 8,
  },
  {
    id: 11,
    desc: "Diet from today.",
    photo: "assets/post/9.jpg",
    date: "12 hour ago",
    userId: 20,
    like: 3,
    comment: 1,
  },
  {
    id: 12,
    desc: "my little girl is growing up",
    photo: "assets/post/10.jpg",
    date: "1 days ago",
    userId: 5,
    like: 9,
    comment: 3,
  },
  {
    id: 13,
    desc: "An apple a day keeps the doctor away",
    photo: "",
    date: "1 days ago",
    userId: 19,
    like: 2,
    comment: 2,
  },
  {
    id: 14,
    desc: "two years ago. you can do it too!",
    photo: "assets/post/11.jpg",
    date: "1 days ago",
    userId: 6,
    like: 67,
    comment: 34,
  },
  {
    id: 15,
    desc: "Birds of a feather flock together!",
    photo: "",
    date: "1 days ago",
    userId: 3,
    like: 40,
    comment: 12,
  },
  {
    id: 16,
    desc: "leave me here please!",
    photo: "assets/post/12.jpg",
    date: "2 days ago",
    userId: 12,
    like: 44,
    comment: 7,
  }
];

export const PersonalPost = [
  {
    id: 1,
    desc: "yum",
    photo: "assets/diary/1.jpg",
    date: "3 hour ago",
    userId: 12,
    like: 6,
    comment: 4,
  },
  {
    id: 2,
    desc: "leave me here please!",
    photo: "assets/diary/2.jpg",
    date: "2 days ago",
    userId: 12,
    like: 44,
    comment: 7,
  },
  {
    id: 3,
    desc: "Hope for the best, prepare for the worst!",
    photo: "",
    date: "2 months ago",
    userId: 12,
    like: 11,
    comment: 3,
  },
  {
    id: 4,
    desc: "Learn to walk before you run...",
    photo: "",
    date: "5 months ago",
    userId: 12,
    like: 9,
    comment: 2,
  },
  {
    id: 5,
    desc: "Happy holidays my friends!",
    photo: "assets/diary/3.jpg",
    date: "7 months ago",
    userId: 12,
    like: 59,
    comment: 44,
  },
  {
    id: 6,
    desc: "absence makes the heart grow fonder",
    photo: "",
    date: "9 months ago",
    userId: 12,
    like: 27,
    comment: 12,
  }
];